<svg-icon [src]="src()" [stretch]="stretch()" [svgStyle]="{ 'width.px':size() }">
</svg-icon>
